import { IsDate, IsNumber, IsOptional, IsString } from 'class-validator';
import { BaseDto } from './base.dto';
import { BusinessEntityDto } from './businessEntity.dto';
import { MerchantDto } from './merchant.dto';

export class BusinessEntityDepartmentDto extends BaseDto {
  id: number;
  merchantBusinessEntity: BusinessEntityDto;
  
  @IsString()
  name: string;

  @IsString()
  departmentCode: string;

  @IsOptional()
  @IsNumber()
  merchantId?: number;

  @IsNumber()
  merchantGroupId: number;

  @IsNumber()
  merchantBusinessEntityId: number;

  @IsDate()
  @IsOptional()
  createdDate?: Date;

  @IsDate()
  @IsOptional()
  modifiedDate?: Date;

  @IsNumber()
  @IsOptional()
  version?: number

  @IsOptional()
  merchant?: MerchantDto;
}
